import React from 'react';
import { isEmpty, reduce, values } from 'lodash';

import InfoMessage, { InfoMessageTypes } from 'src/components/shared/InfoMessage';

export const GENERAL_ERROR_MSG = 'Oops, something went wrong. Please try again.';

export const FORM_MESSAGES = {
    passwordValidation: 'The password must be at least 6 characters.',
    requiredField: 'Required',
    invalidEmail: 'Invalid email address',
};

/**
 * @see https://www.thepolyglotdeveloper.com/2015/05/use-regex-to-test-password-strength-in-javascript/
 */
export const STRONG_PASSWORD_REGEX = /^(?=.{6,})/;

export const getErrorMessage = (error: string, floatIcon: boolean = false) => {
    return getInfoMessage(error, 'ERROR', floatIcon);
};

export const getInfoMessage = (
    msg: string,
    type: InfoMessageTypes = 'DEFAULT',
    floatIcon: boolean = false
) => <InfoMessage content={msg} type={type} floatIcon={floatIcon} />;

/**
 *
 * @param valueObj
 * Typically a `FormValues` object
 */
export const hasAllValues = (valueObj: { [key: string]: any }) => {
    return reduce(
        values(valueObj),
        function (memo, value) {
            return memo && !isEmpty(value?.toString());
        },
        true
    );
};

/**
 *
 * @param values
 * An object with an `email` attribute
 */
export const validateEmail = (values: { email?: string }) => {
    const error: { email?: string } = {};

    if (!values.email) {
        error.email = FORM_MESSAGES.requiredField;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        error.email = FORM_MESSAGES.invalidEmail;
    }

    return error;
};

export const validatePassword = (values: { password?: string }) => {
    const error: { password?: string } = {};

    if (!values.password) {
        error.password = FORM_MESSAGES.requiredField;
    } else if (!STRONG_PASSWORD_REGEX.test(values.password)) {
        error.password = FORM_MESSAGES.passwordValidation;
    }
    return error;
};
